/**
 * 製造分類から生産ラインを求めるユーティリティ。
 * バックエンド (backend2/app/utils/line_key.py) と同じ正規化ルールを保つ必要がある。
 */

/** 稼働ラインとして選択させないライン（製造分類が不明な品目） */
const UNASSIGNED_LINE = 'Z'

/** 製造分類（例: 'A-PR', 'B-LC25', 'C'）を生産ラインのキーへ正規化する */
export const normalizeLineKey = (manufacturingClass: string): string => {
  if (!manufacturingClass) return 'OTHER'
  if (manufacturingClass.startsWith('A')) return 'A'
  if (manufacturingClass.startsWith('B')) return 'B'
  return manufacturingClass
}

/** 品目マスタに実在する生産ラインの一覧 */
export const deriveLineMaster = (
  itemMaster: ReadonlyArray<{ 製造分類: string }> | undefined | null,
): string[] => {
  if (!itemMaster) return []
  return Array.from(new Set(itemMaster.map(item => normalizeLineKey(item.製造分類)))).sort()
}

/** 既定で稼働させるライン（実在するラインからZを除いたもの） */
export const deriveDefaultLines = (
  itemMaster: ReadonlyArray<{ 製造分類: string }> | undefined | null,
): string[] => deriveLineMaster(itemMaster).filter(line => line !== UNASSIGNED_LINE)

/** 稼働ライン指定を、品目マスタに実在するラインだけに絞る */
export const filterExistingLines = (lines: string[] | undefined, lineMaster: string[]): string[] =>
  (lines ?? []).filter(line => lineMaster.includes(line))
